import { render, staticRenderFns } from "./Teaser.vue?vue&type=template&id=24d2549c&scoped=true&lang=pug&"
import script from "./Teaser.vue?vue&type=script&lang=js&"
export * from "./Teaser.vue?vue&type=script&lang=js&"
import style0 from "./Teaser.vue?vue&type=style&index=0&id=24d2549c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d2549c",
  null
  
)

export default component.exports